// extracted by mini-css-extract-plugin
module.exports = {"issueCard":"issuecard-module--issueCard--3fSXM","issueCardText":"issuecard-module--issueCardText--3Jo7o"};